export default __webpack_public_path__ + "static/media/farelo-soja.1a20a244.svg";